import { render, staticRenderFns } from "./TestimoniEdit.vue?vue&type=template&id=29305a2c"
import script from "./TestimoniEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimoniEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports